import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import SessionAddEdit from "../SessionAddEdit/Index";
import TermAddEdit from "../TermAddEdit/Index";
import {
  deleteSession,
  deleteSessions,
  getSessionTerm,
} from "../../../apis/Session";
import { useAuthStore } from "../../../store/AuthStore";
import { useSchoolStore } from "../../../store/SchoolStore";
import utils from "../../../utils";
import constants from "../../../constants";

const SessionList = ({ toast }) => {
  
  const [state] = useAuthStore();
  const [{ schoolId }] = useSchoolStore();

  let emptySession = {
    id: null,
    schoolId: schoolId,
    name: "",
    startDate: "",
    endDate: "",
    createdBy: state.email,
    modifiedBy: state.email,
    termDto: [],
  };

  const [sessions, setSessions] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [sessionDialog, setSessionDialog] = useState(false);
  const [termDialog, setTermDialog] = useState(false);
  const [deleteSessionDialog, setDeleteSessionDialog] = useState(false);
  const [deleteSessionsDialog, setDeleteSessionsDialog] = useState(false);
  const [session, setSession] = useState(emptySession);
  const [selectedSessions, setSelectedSessions] = useState(null);
  const [, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toastSL = useRef(toast);
  const [selectedDataList, setSelectedDataList] = useState(null);
  const dt = useRef(null);

  async function fetchSessionTermData() {
    var res = await getSessionTerm(schoolId);
    console.log(res.data);
    setSessions(res.data);
  }

  useEffect(() => {
    fetchSessionTermData();
  }, 
  [
    termDialog,
    sessionDialog,
    deleteSessionDialog,
    deleteSessionsDialog,
    globalFilter,
  ]);

  const openNew = () => {
    setSession(emptySession);
    setSubmitted(false);
    setSessionDialog(true);
  };

  const confirmDeleteSelected = () => {
    setDeleteSessionsDialog(true);
  };

  const leftToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedDataList || !selectedDataList.length}
        />
      </div>
    );
  };

  const actionBodyTemplateTerms = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" rounded outlined className="mr-2" />
        <Button icon="pi pi-trash" rounded outlined severity="danger" />
      </React.Fragment>
    );
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        <h5>Term for {data.name}</h5>
        <Button
          icon="pi pi-plus"
          rounded
          outlined
          onClick={newTerm}
          severity="success"
          className="mb-2"
        />
        <DataTable value={data.termDto}>
          <Column field="name" header="Name" sortable></Column>
          <Column field="startDate" header="Start Date" sortable></Column>
          <Column field="endDate" header="End Date" sortable></Column>
          <Column
            exportable={false}
            style={{ minWidth: "20%" }}
            body={actionBodyTemplateTerms}
          ></Column>
        </DataTable>
      </div>
    );
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const rightToolbarTemplate = () => {
    return (
      <Button
        label="Export"
        icon="pi pi-upload"
        className="p-button-help"
        onClick={exportCSV}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          className="mr-2"
          onClick={() => editSession(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteSession(rowData)}
        />
      </React.Fragment>
    );
  };

  const newTerm = (sessionData) => {
    setSession(sessionData);
    setSubmitted(false);
    setTermDialog(true);
  };

  const editSession = (sessionData) => {
    setSession({ ...sessionData });
    setSessionDialog(true);
  };

  const confirmDeleteSession = (session) => {
    setSession(session);
    setDeleteSessionDialog(true);
  };

  const hideDeleteSessionDialog = () => {
    setDeleteSessionDialog(false);
  };

  const hideDeleteSessionsDialog = () => {
    setDeleteSessionsDialog(false);
  };

  const deleteSessionFunc = async () => {
    let resp = {
      data: null,
      responseCode: "",
      responseCodeDescription: "",
    };

    try {
      if (session && session.id) {
        resp = await deleteSession(session.id);
        setDeleteSessionDialog(false);
        setSession(emptySession);
        toastSL.current.show(
          utils.toastCallback({
            severity: "success",
            summary: "Successful",
            detail: resp.responseCodeDescription,
          })
        );
      }
    } catch (error) {
      if (error.response) {
        resp = error.response;

        toastSL.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toastSL.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const deleteSelectedSessions = async () => {
    let resp = {
      data: null,
      responseCode: "",
      responseCodeDescription: "",
    };

    try {
      let _sessions = sessions.filter((val) => !selectedSessions.includes(val));
      resp = await deleteSessions(_sessions);
      setDeleteSessionsDialog(false);
      setSelectedSessions(null);
      toastSL.current.show(
        utils.toastCallback({
          severity: "success",
          summary: "Successful",
          detail: resp.responseCodeDescription,
        })
      );
    } catch (error) {
      if (error.response) {
        resp = error.response;

        toastSL.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Submit Error",
            detail: resp.responseCodeDescription,
          })
        );
      } else {
        toastSL.current.show(
          utils.toastCallback({
            severity: "error",
            summary: "Network Error",
            detail: constants.networkErrorMessage,
          })
        );
      }
    }
  };

  const deleteSessionDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteSessionDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={async () => await deleteSessionFunc()}
      />
    </React.Fragment>
  );

  const deleteSessionsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteSessionsDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedSessions}
      />
    </React.Fragment>
  );

  const allowExpansion = (rowData) => {
    return rowData.termDto &&
      Array.isArray(rowData.termDto) &&
      rowData.termDto.length >= 0
      ? rowData.termDto.length > 0
      : true;
  };

  const onRowExpand = (event) => {
    toastSL.current.show({
      severity: "info",
      summary: "Term Expanded",
      detail: event.data.name,
      life: 3000,
    });
  };

  const collapseAll = () => {
    setExpandedRows(null);
  };

  const onRowCollapse = (event) => {
    toastSL.current.show({
      severity: "success",
      summary: "Term Collapsed",
      detail: event.data.name,
      life: 3000,
    });
  };

  const expandAll = () => {
    let _expandedRows = {};

    sessions.forEach((p) => (_expandedRows[`${p.id}`] = true));

    setExpandedRows(_expandedRows);
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0">Manage Sessions</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
      <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} text />
      <Button
        icon="pi pi-minus"
        label="Collapse All"
        onClick={collapseAll}
        text
      />
    </div>
  );

  return (

    <div>

      <Toast ref={toastSL} />

      <div className="card">

        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          value={sessions}
          onSelectionChange={(e) => setSelectedDataList(e.value)}
          expandedRows={expandedRows}
          selection={selectedDataList}
          onRowToggle={(e) => setExpandedRows(e.data)}
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey="id"
          header={header}
          globalFilter={globalFilter}
          tableStyle={{ minWidth: "60rem" }}
        >

          <Column expander={allowExpansion} style={{ width: "5rem" }} />

          <Column selectionMode="multiple" exportable={false}></Column>

          <Column
            field="name"
            header="Name"
            style={{ width: "20%" }}
            sortable
          />

          <Column
            field="startDate"
            header="Start Date"
            style={{ width: "20%" }}
          ></Column>

          <Column
            field="endDate"
            header="End Date"
            style={{ width: "20%" }}
          ></Column>

          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{ minWidth: "20%" }}
          ></Column>

        </DataTable>

      </div>

      <Dialog
        visible={deleteSessionDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteSessionDialogFooter}
        onHide={hideDeleteSessionDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {session && (
            <span>
              Are you sure you want to delete <b>{session.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteSessionsDialog}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteSessionsDialogFooter}
        onHide={hideDeleteSessionsDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {session && (
            <span>Are you sure you want to delete the selected sessions?</span>
          )}
        </div>
      </Dialog>

      <SessionAddEdit
        toast={toastSL}
        sessionAE={session}
        sessionDialog={sessionDialog}
        setSessionDialog={setSessionDialog}
      />

      <TermAddEdit
        toast={toastSL}
        dataDialog={termDialog}
        sessionId={session.id}
        setDataDialog={setTermDialog}
      />

    </div>

  );

};

export default SessionList;
